import { z } from "zod"

/** A store whose stats and trends an admin can include in a combined view. */
export interface AdminStatsStore {
  id: string
  name: string
}

/**
 * A saved set of stores on Statistik and Trender, shared by all admins.
 * `storeIds` only holds stores that can still be chosen.
 */
export interface AdminStoreCollection {
  id: string
  name: string
  storeIds: string[]
}

const AdminStoreCollectionNameSchema = z
  .string()
  .trim()
  .min(1, "Namnet får inte vara tomt")
  .max(100)

export const CreateAdminStoreCollectionSchema = z.object({
  name: AdminStoreCollectionNameSchema,
  storeIds: z.array(z.string().uuid()).min(1, "Välj minst en butik").max(500),
})

export const RenameAdminStoreCollectionSchema = z.object({
  name: AdminStoreCollectionNameSchema,
})

export type CreateAdminStoreCollection = z.infer<
  typeof CreateAdminStoreCollectionSchema
>
export type RenameAdminStoreCollection = z.infer<
  typeof RenameAdminStoreCollectionSchema
>
